// Current California legislative session as a dashed string, e.g. "2025-2026".
// A session runs Dec 1 of the prior even year through Nov 30 two years later, so December of an
// even year already belongs to the next session. Keep in step with utils/sessionAccess.js.
export const getCurrentSession = () => {
  const now = new Date();
  const year = now.getFullYear();
  const startYear = now.getMonth() === 11 ? year + 1 : year % 2 !== 0 ? year : year - 1;
  return `${startYear}-${startYear + 1}`;
};
